<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout row>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :items="data"
                    class="elevation-1"
                    hide-default-footer
                    sort-by="timestamp"
                    sort-desc
                    :items-per-page="data.length + 1"
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <span>
                                Zeigt die letzten 10 Einträge von Router-Nachrichten.
                            </span>
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="loadData">
                                Aktualisieren
                            </v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.entries="{ item }">
                      <span v-for="e in item.entries" :key="e.key">
                        {{ e.key }}: {{ e.value }} <br>
                      </span>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        data: [],
        headers: [
            // {text: 'uuid (generiert)', value: 'uuid'},
            {text: 'deviceUuid (DB Verlinkung)', value: 'deviceUuid'},
            {text: 'timestamp', value: 'timestamp'},
            {text: 'state', value: 'state'},
            {text: 'program', value: 'program'},
            {text: 'entries', value: 'entries'},
        ],
    }),
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            axios.get('/telematics/api/record/debug/')
                .then(response => {
                    this.data = response.data
                })
        }
    }
};
</script>
